import type { Slide } from "@hali-shares/deck-schema";
import { ConceptSlide } from "./ConceptSlide";
import { usePresenter } from "./context";
import { FlowSlide } from "./flow/FlowSlide";
import { PollSlide } from "./PollSlide";
import { ReferencesSlide } from "./ReferencesSlide";
import { ScreenshotSlide } from "./ScreenshotSlide";
import { SectionSlide } from "./SectionSlide";
import { TimelineSlide } from "./TimelineSlide";
import { TitleSlide } from "./TitleSlide";
import { VideoSlide } from "./VideoSlide";

export function SlideView({ slide, slideIndex, stop }: { slide: Slide; slideIndex: number; stop: number }) {
  const { model } = usePresenter();
  if (slide.kind === "title") return <TitleSlide />;
  if (slide.kind === "section") return <SectionSlide sectionId={slide.sectionId} />;
  const block = model.blocks.get(slide.blockId)?.block;
  switch (block?.type) {
    case "concept":
      return <ConceptSlide block={block} />;
    case "flow":
      return <FlowSlide block={block} slideIndex={slideIndex} stop={stop} />;
    case "screenshot":
      return <ScreenshotSlide block={block} slideIndex={slideIndex} stop={stop} />;
    case "poll":
    case "quiz":
      return <PollSlide block={block} />;
    case "video":
      return <VideoSlide block={block} />;
    case "timeline":
      return <TimelineSlide block={block} stop={stop} />;
    case "references":
      return <ReferencesSlide block={block} />;
    default:
      return null;
  }
}
